export default "__VITE_ASSET__de41b2d2__"